import { render, staticRenderFns } from "./SDialogUpdateInventoryComp.vue?vue&type=template&id=1407dfde&"
import script from "./SDialogUpdateInventoryComp.vue?vue&type=script&lang=js&"
export * from "./SDialogUpdateInventoryComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports